module.exports = __webpack_public_path__ + "static/img/aboutus11_03.917d980.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/aboutus11_03.png
// module id = dH2/
// module chunks = 1